
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { scrollToElement } from "@/helpers/UI/ScrollHelpers";

@Component
export default class BaseCardListDetail extends Vue {
  @Prop({ required: true })
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  data!: any[];

  @Prop({ required: false, default: false })
  loading!: boolean;

  @PropSync("selectedItem", { default: Object })
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  selectedItemSync!: any | null;

  /** Bind the card list to this to render paged records only and avoid browser performance issues. */
  @PropSync("pagedData", { type: Array })
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  pagedDataSync!: any[];

  page = 1;
  pageLength = 100;

  get showNextPageButton() {
    return this.page * this.pageLength < this.data.length;
  }

  get showPreviousPageButton() {
    return this.page > 1;
  }

  nextPage(): void {
    this.page++;
    this.setPagedData();
    this.moveToTopOfCardList();
  }

  previousPage(): void {
    this.page--;
    this.setPagedData();
    this.moveToTopOfCardList();
  }

  setPagedData(): void {
    this.pagedDataSync = [
      ...this.data.slice(
        (this.page - 1) * this.pageLength,
        this.page * this.pageLength
      ),
    ];
  }

  moveToTopOfCardList(): void {
    if (this.$vmq.lg) {
      const element = document.getElementById("v-card-list-items");
      if (element) element.scrollTop = 0;
    } else {
      scrollToElement("v-card-list-items");
    }
  }

  @Watch("data")
  dataChanged(): void {
    this.page = 1;
    this.setPagedData();
  }
}
